<template>
  <div>
    <card v-if="loading">
      <small-loading :loading="true"></small-loading>
    </card>
    <card titulo="Informações do Livro" v-else-if="ficha && (tipoRegistro || informacoesLivro.length)">
      <p><span class="font-weight-500">{{ isProtocoloEspecialNotas ? 'Tipo de Livro: ' : 'Tipo de Registro: ' }}</span><span>{{tipoRegistro}}</span></p>
      <LivroSimulacao :livros="informacoesLivro" />
      <p v-if="informacoesLivro.length > 1"><span class="font-weight-500">Quantidade Total de Folhas: </span><span>{{informacoesLivro?.[0]?.quantidadeFolhasTotal}}</span></p>
    </card>
  </div>
</template>

<script>
import Card from "@/components/Layout/components/Card.vue";
import IndicadorAbstractService from "@/business/indicadores/IndicadorAbstractService";
import SmallLoading from "@/components/SmallLoading.vue";
import LivroSimulacao from "@/components/IndicadorGeneric/Detalhes/LivroSimulacao.vue";

export default {
  name: "InformacoesLivro",
  components: {LivroSimulacao, SmallLoading, Card},
  props: {
    ficha: { type: String, required: true },
    tipoRegistro: { type: String, required: true },
    isProtocoloEspecialNotas: { type: Boolean, default: false }
  },

  data() {
    return {
      loading: false,
      informacoesLivro: []
    };
  },

  async mounted() {
    this.loading = true;

    this.informacoesLivro = await IndicadorAbstractService.getAtoAberturaByIndicador(this.ficha);

    this.loading = false;
  }
}
</script>

<style>

</style>
